export function decodeAndFormatHtml(str: string): TrustedHTML {
  const parser = new DOMParser();
  const doc = parser.parseFromString(str, "text/html");
  const txt = doc.body.textContent;
  return txt as TrustedHTML;
}